export default __webpack_public_path__ + "static/media/login-page-dark.77eba65e.png";